var pug = require("!../../../../node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cion-row\u003E\u003Cion-col\u003E\u003Cion-spinner name=\"crescent\"\u003E\u003C\u002Fion-spinner\u003E\u003C\u002Fion-col\u003E\u003C\u002Fion-row\u003E";;return pug_html;};
module.exports = template;